import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import AppWrapper from './app/AppWrapper';
import reportWebVitals from './app/reportWebVitals';
import store from './store';
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    //we comment the strictMode to stop calling api mulitple times.
    // <React.StrictMode>
        <HashRouter>
            <Provider store={store}>
                <AppWrapper />
            </Provider>
        </HashRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
